import {Components} from "../components";

export class GetViews {
    static receiver(url, data = {}) {
        return Promise.resolve($.ajax({
            url: url,
            type: 'GET',
            data: data
        }))
    }

    static viewGet(selector, data) {

        let convertedData = {};

        $.each(data, function () {
            if (convertedData[this.name]) {
                if (!convertedData[this.name].push) {
                    convertedData[this.name] = [convertedData[this.name]];
                }
                convertedData[this.name].push(this.value || '');
            } else {
                convertedData[this.name] = this.value || '';
            }
        });

        convertedData = {
            ...convertedData,
            ...{
                _token: window.token.content,
                _method: 'POST'
            }
        }

        return $.ajax({
            url: $(selector).data('src'),
            type: 'post',
            data: convertedData,
            async: false,
            success: function (data) {
                let viewHTML = data['html'][$(selector).data('target')];

                $(selector).append(viewHTML);

                new Components($(selector), false);

            }
        })

        // ajaxPromise.then(function(data){
        //
        //     let viewHTML = data['html'][$(selector).data('target')];
        //
        //     $(selector).append(viewHTML);
        //
        //     new Components($(selector), false);
        //
        // });
    }
}
